import { styled, selectTheme, Box } from '@creditas-ui/react'

export const ContainerTab = styled.div`
  padding: 60px 0 10px;
  @media screen and (min-width: 980px) {
    padding: 20px 100px 10px;

    button {
      width: 208px;
    }
  }

  button {
    background: white;
    cursor: pointer;
    height: 72px;
    padding: 0 10px;
  }
`

export const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #edf0ef;

  @media screen and (max-width: 980px) {
    justify-content: space-between;
  }

`

export const Item = styled(Box)`
  border-bottom: ${props => (props.active ? '2px solid #49E295' : '')};

  p {
    color: ${props =>
      props.active
        ? selectTheme('colors.neutral.90')
        : selectTheme('colors.neutral.40')};
    transition: color 0.1s ease-in-out;
  }
`
